import { DealCenterFlag } from '@/models/GoldVision/GoldVisionDeal';
import { createSlice } from '@reduxjs/toolkit';

import { fetchDealFlags } from './thunk';

type DealsManagementState = {
  dealFlags: {
    data: DealCenterFlag[];
    loading: boolean;
  };
};

const initialState: DealsManagementState = {
  dealFlags: {
    data: [],
    loading: false,
  },
};

const dealsManagementSlice = createSlice({
  name: 'dealsManagement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDealFlags.pending, (state) => {
        state.dealFlags.loading = true;
      })
      .addCase(fetchDealFlags.fulfilled, (state, action) => {
        state.dealFlags.loading = false;
        state.dealFlags.data = action.payload;
      })
      .addCase(fetchDealFlags.rejected, (state) => {
        state.dealFlags.loading = false;
      });
  },
});

export default dealsManagementSlice.reducer;
